module.exports = {
  deliveryComplaintCategoryId: '113',
  seo: {
    title: 'Contact | Help With Recipe Boxes | Gousto',
    meta: [
      {
        name: 'description',
        content:
          'Contact our support team for help with your recipe kit box or food delivery service. Get help today.',
      },
      {
        name: 'keywords',
        content: 'contact, help, recipe box, food delivery service',
      },
    ],
  },
}
